import dayjs from 'dayjs';

/* eslint-disable import/prefer-default-export */
const MAX_RATES = [43200000, 34560000, 8640000, 864000];

// Values taken from appAwareDashboard mocks

const getDateFormatted = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const getRateLimitUsageData = (startDate, endDate) => {
    const start = getDateFormatted(startDate);
    const end = getDateFormatted(endDate);

    const maxRate = MAX_RATES[Math.floor(Math.random() * MAX_RATES.length)];

    // We calculate how many days we have to generate between the start and end date
    // If end date is after today, we limit it to today
    const startDateObj = dayjs(startDate);
    const endDateObj = dayjs(endDate);
    const today = dayjs();
    const effectiveEndDate = endDateObj.isAfter(today, 'day') ? today : endDateObj;
    const diffDays = effectiveEndDate.diff(startDateObj, 'days') + 1;

    return {
        startDate: start,
        endDate: end,
        usage: Array.from({length: diffDays}, () => {
            const usedQuota = Math.floor(Math.random() * maxRate);
            // 0: used quota, 1: remaining quota
            return [usedQuota, maxRate - usedQuota];
        }),
        maxRate
    };
};
